/* repX — About page: reveal-on-scroll (progressive enhancement).
   Content is fully visible if this file never runs. */
(function () {
  if (window.__rxAbout) return;
  window.__rxAbout = true;

  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var io = null;
  var SELECTOR = '[data-rx-reveal]:not(.is-in), [data-rx-io]:not(.is-in)';

  function show(el) { el.classList.add('is-in'); }

  function init(scope) {
    var els = (scope || document).querySelectorAll(SELECTOR);
    if (!els.length) return;

    if (reduce || designMode || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, show);
      return;
    }

    root.classList.add('rx-js');

    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            show(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }

    var vh = window.innerHeight || root.clientHeight;
    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      // Already on screen when the script runs: show instantly (no flash).
      if (r.top < vh * 0.92 && r.bottom > 0) show(el);
      else io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
